<section>
  <img src="assets/images/no-data/no-data.webp" alt="empty-data">
</section>
